import React from 'react';
import { usePSIFlowReminders } from '@/hooks/usePSIFlow';

const FlowReminderBadge: React.FC = () => {
  const { data } = usePSIFlowReminders();
  const count = data?.total || 0;

  if (count === 0) return null;

  return (
    <span className="absolute -top-1 -right-1 flex items-center justify-center min-w-[18px] h-[18px] px-1 text-[10px] font-bold text-white bg-red-500 rounded-full animate-pulse">
      {count > 99 ? '99+' : count}
    </span>
  );
};

export default FlowReminderBadge;
